module.exports = __webpack_public_path__ + "static/gallery41-b6ea0e6c92a46f8f559d37c53e36d29e.png";